import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "mfa",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /*  webpackChunkName: "mfa-configuration" */ "./components/MFAConfiguration"
      ),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
});
